import {
    createContext,
    useContext,
    useState,
    type Dispatch,
    type ReactNode,
    type SetStateAction,
} from 'react';

export type FloatingFormSaveRegistration = {
    submitLabel: string;
    submitDisabled: boolean;
    loading: boolean;
    requestSubmit: () => void;
};

const RegistrationStateContext = createContext<FloatingFormSaveRegistration | null>(null);
const SetRegistrationContext = createContext<Dispatch<SetStateAction<FloatingFormSaveRegistration | null>> | null>(null);

export function FloatingFormSaveProvider({ children }: { children: ReactNode }) {
    const [registration, setRegistration] = useState<FloatingFormSaveRegistration | null>(null);

    return (
        <SetRegistrationContext.Provider value={setRegistration}>
            <RegistrationStateContext.Provider value={registration}>
                {children}
            </RegistrationStateContext.Provider>
        </SetRegistrationContext.Provider>
    );
}

export function useFloatingFormSaveRegistration(): FloatingFormSaveRegistration | null {
    return useContext(RegistrationStateContext);
}

export function useSetFloatingFormSaveRegistration(): Dispatch<SetStateAction<FloatingFormSaveRegistration | null>> | null {
    return useContext(SetRegistrationContext);
}
